import { TBundleQcBgDB, TBundleQcBgDBLockDetails, TStationDetails, TUserAction } from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum BundleQcDBActionTypes {
  UpdateBundleQcBgDBLockDetails = 'UpdateBundleQcBgDBLockDetails',
  AcquireLockAndSyncIncompleteBundles = 'AcquireLockAndSyncIncompleteBundles',
  SyncIncompleteBundlesAndReleaseLock = 'SyncIncompleteBundlesAndReleaseLock',
  UpdateBundleQcBgDBAndReleaseLock = 'UpdateBundleQcBgDBAndReleaseLock',
  ReleaseBundleQcBgDBLock = 'ReleaseBundleQcBgDBLock',
  BundleQcNoAction = 'BundleQcNoAction',
}

export class BundleQcNoAction implements Action {
  readonly type = BundleQcDBActionTypes.BundleQcNoAction;
  constructor() {}
}

export class UpdateBundleQcBgDBLockDetails implements Action {
  readonly type = BundleQcDBActionTypes.UpdateBundleQcBgDBLockDetails;
  constructor(public lockDetails: TBundleQcBgDBLockDetails) {}
}
export class AcquireLockAndSyncIncompleteBundles implements Action {
  readonly type = BundleQcDBActionTypes.AcquireLockAndSyncIncompleteBundles;
  constructor(public stationDetails: TStationDetails, public chainAction: TUserAction = {}) {}
}
export class SyncIncompleteBundlesAndReleaseLock implements Action {
  readonly type = BundleQcDBActionTypes.SyncIncompleteBundlesAndReleaseLock;
  constructor(public stationDetails: TStationDetails, public chainAction: TUserAction = {}) {}
}

export class UpdateBundleQcBgDBAndReleaseLock implements Action {
  readonly type = BundleQcDBActionTypes.UpdateBundleQcBgDBAndReleaseLock;
  constructor(public bundleQcBgDB: TBundleQcBgDB, public chainAction: TUserAction = {}) {}
}

export class ReleaseBundleQcBgDBLock implements Action {
  readonly type = BundleQcDBActionTypes.ReleaseBundleQcBgDBLock;
  constructor() {}
}

export type TBundleQcActions =
  | BundleQcNoAction
  | ReleaseBundleQcBgDBLock
  | UpdateBundleQcBgDBAndReleaseLock
  | UpdateBundleQcBgDBLockDetails;
